import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";

import Snackbar from "../../../../Snackbar";
import {Plus, X,} from 'lucide-react';
import { createNewRichContent } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";

import RichTextEditor from "../../../UI/RichTextEditor";
import AreYouSurePopUp from "../ContentPopUp/AreYouSurePopUp";
const RichContentCard =({content,contentId,postParentId,setFireStatus})=>{
      function decodeHtmlEntities(str) {
  const txt = document.createElement("textarea");
  txt.innerHTML = str;
  return txt.value;
}

    const dispatch = useDispatch();
   const [snackbarVisible, setSnackbarVisible] = useState(false);
   const [snackbarColor, setSnackbarColor] = useState("#958FDA");
   const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
        setSnackbarVisible(true);
      };
      
       const hideSnackbar = () => {
        setSnackbarVisible(false);
      };
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
      {
        
        dispatch({type: "CURSOR",payload:true  });
    
        dispatch({type: "CURSORTEXT",payload:CursorText})
        dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
        dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
      }
       
      const handleMouseLeave = () => {
        
        dispatch({type: "CURSOR",payload:false})
    
        dispatch({type: "CURSORTEXT",payload:""})
    
        dispatch({type: "CURSORTEXTBG",payload:""})
        dispatch({type: "CURSORTEXTCOLOR",payload:""})
      
    
    }
      
      ;
      
     const token = useSelector((state)=>state?.course?.course?.token);
     const currentToken = useSelector((state)=>state?.user?.user?.token);
     const user_email = useSelector((state)=>state?.user?.user?.user_email
    );
    
    const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
    
    const courseData = useSelector((state)=>state?.course?.course);
    
    const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
    const appId = useSelector((state)=>state?.app?.app?.ID);
    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
   

       const [topicShow, setTopicShow] = useState('RichText');
       const [titleText, setTitleText] = useState('');
   const [itemArrLoading, setItemArrLoading] = useState([{},{}]);
     const [currentTopic, setCurrentTopic] = useState({});
     const [deleteTopicPopUp, setDeleteTopicPopUp] = useState(false);
      
     const [itemArr, setItemArr] = useState([]);
      const [loader , setLoader] =useState({status:false});
const handleUpdateNewRichContent=()=>{
       
       
       
       setLoader({status:true});
       
         const apiData = dispatch(createNewRichContent({contentId:contentId,mimeType:"",field:"contentFormatedText",value:contentk,
                     postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                     currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                     editType:"updateField",appToken:AppToken,appId:appId}
                     ));
         /* get response as Promise   */
         apiData.then(response => {
           if(response){     
             if(response?.content){
             
           setResponseMessage(response?.message);
           setSnackbarColor("rgba(144, 202, 249,1)");
        
         setTimeout(()=>{
           
              
           },100)
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
       },1000)
          }else{
           setResponseMessage("Something Went Wrong...");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
          }
             
          
          if(response?.logout){
          
           setResponseMessage("You are Logged Out!!!");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
           setTimeout(()=>{
             dispatch({type:"LOGOUT"});
       
           },3000)
           
         }
       /* resetting Login input Fields */
       
           }else{
             setResponseMessage("Something Went Wrong...");
             
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)    }
       
         }).catch(error => {
        
           //popup of error Info
           setResponseMessage("Something Went Wrong...");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
           console.error(error);
         });
        
         }
const handleDeleteRichContent=()=>{
       
       
       
       setLoader({status:true});
       
         const apiData = dispatch(createNewRichContent({contentId:contentId,
                     postParent:postParentId,userEmail:user_email?user_email:"",menuOrder:itemArr?.length+1,
                     currentToken:currentToken?currentToken:"",visibility:"public",status:"active",
                     editType:"delete",appToken:AppToken,appId:appId}
                     ));
         /* get response as Promise   */
         apiData.then(response => {
           if(response){     
             setFireStatus(true)
         setTimeout(()=>{
            setFireStatus(false)
              setContent("")
           },100)
             
          
          if(response?.logout){
          
           setResponseMessage("You are Logged Out!!!");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
           setTimeout(()=>{
             dispatch({type:"LOGOUT"});
       
           },3000)
           
         }
       /* resetting Login input Fields */
       
           }else{
             setResponseMessage("Something Went Wrong...");
             
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)    }
       
         }).catch(error => {
        
           //popup of error Info
           setResponseMessage("Something Went Wrong...");
             
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)
           console.error(error);
         });
        
         }

 const [contentk, setContent] = useState(decodeHtmlEntities(content));
 const [deleteStatus, onDeleteStatus] =  useState(true);
 
    return(<> {deleteTopicPopUp?<AreYouSurePopUp loadingText="Deleting..."  title="Delete This Item" type="deleteTopic"
 closePopUp={()=>{setDeleteTopicPopUp(false)}}
 onClickPopup={(type)=>{handleDeleteRichContent();
  }}/>:""}
    <RichTextEditor value={(contentk)}  deleteStatus={deleteStatus} onDelete={()=>{setDeleteTopicPopUp(true);}} onChange={(v)=>{setContent(v);setTimeout(()=>{handleUpdateNewRichContent()},1000)}} />  
    </>)
}
export default RichContentCard;